import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { LocationListComponent } from "./location-list.component";
import { NgxPaginationModule } from "ngx-pagination";

@NgModule({
    declarations: [
      LocationListComponent
    ],
    imports: [
      FormsModule,
      CommonModule,
      RouterModule,
      NgxPaginationModule
    ]
})
export class LocationListModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/location/list/location-list.module.ts